<template>
  <div class="usuarios">
    <v-card class="mt-3">
      <div class="pa-3" style="font-size: 16px">
        <div><strong>Código Usuário:</strong> {{ usuario.identificadorusuario }}</div>
        <div><strong>Nome:</strong> {{ usuario.nomeusuario }}</div>
        <div><strong>E-mail:</strong> {{ usuario.emailusuario }}</div>
      </div>
    </v-card>

    <div class="mt-2 mb-2 btn-acoes">
      <div class="btn-acoes-itens">
        <v-btn icon to="/atena/usuario">
          <v-icon>arrow_back</v-icon>
        </v-btn>
      </div>
      <div class="btn-acoes-itens" style="text-align: right">
        <v-btn color="cyan" small dark :to="{ path: `/atena/usuario/${idUsuario}/perfil/novo` }" class="rounded-sm font-weight-regular" width="90px">Novo</v-btn>
      </div>
    </div>

    <v-alert type="error" v-if="usuarioPerfis.length <= 0" value="true" dark class="mt-3 mb-3">
      <div>Nenhum perfil de usuário cadastrado!</div>
    </v-alert>
    <v-card v-else style="overflow-y: auto">
      <table class="table-siged">
        <thead>
          <tr>
            <th>Código</th>
            <th>Perfil</th>
            <th>SubPerfil</th>
            <th>Matrícula RH</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="perfil in usuarioPerfis" :key="perfil.identificadorusuarioperfil">
            <td class="centro">{{ perfil.identificadorusuarioperfil }}</td>
            <td class="centro">{{ perfil.nomeperfil }}</td>
            <td class="centro">{{ perfil.nomesubperfil || '-' }}</td>
            <td class="centro">{{ (perfil.cdpessoal && perfil.cdpessoal) ? `${perfil.cdpessoal} - ${perfil.cdmatric}` : '-' }}</td>
            <td class="centro">
              <v-btn icon title="Editar" class="aulas-btn-acao" :to="{ path: `/atena/usuario/${perfil.identificadorusuario}/perfil/${perfil.identificadorusuarioperfil}` }">
                <v-icon class="btn-acoes-icon">edit</v-icon>
              </v-btn>
              <v-btn icon title="Excluir" class="aulas-btn-acao" @click="excluir(perfil.identificadorusuarioperfil)">
                <v-icon color="red">delete_forever</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </table>
    </v-card>

    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/repositories/RepositoryFactory';

const AtenaUsuarioRepository = RepositoryFactory.get('atenaUsuario');

export default {
  name: 'UsuarioPerfil',
  props: {
    idUsuario: [Number, String],
  },
  data() {
    return {
      usuarioPerfis: [],
      usuario: {},
      snackbar: false,
      submitText: '',
    };
  },
  async beforeRouteEnter(to, from, next){
    const { data } = await AtenaUsuarioRepository.getUsuarioPerfis(to.params.idUsuario);

    next(vm => vm.reload(data));
  },
  methods: {
    async reload(data = null) {
      try {
        if(!data) {
          this.$Progress.start();
          const retorno = await AtenaUsuarioRepository.getUsuarioPerfis(this.idUsuario);
          data = retorno.data;
        }
        this.usuarioPerfis = data.results.userPerfis;
        this.usuario = data.results.user;
      } finally {
        this.$Progress.finish();
      }
    },
    async excluir(id) {
      const confirmar = await this.$sgal({
        title: 'Tem certeza?',
        text: 'Deseja realmente excluir este perfil de usuário?',
        type: 'warning',
        buttons: [
          { text: 'Excluir', color: 'red', response: true },
          { text: 'Cancelar', color: 'grey', response: false },
        ],
      });
      if(!confirmar) { return; }

      try {
        const { data } = await AtenaUsuarioRepository.deleteUsuarioPerfil(this.idUsuario, id);

        this.submitText = data.message;
        this.snackbar = true;
        if(this.paginaAtual > 1 && this.telas.length == 1) { this.paginaAtual--; }
        this.reload();
      }catch(error) {
        if(error.response) {
          this.$sgal({
            title: 'Não foi possível!',
            text: error.response.data.errorMessage[0],
            type: 'notification',
          });
        }
      }
    },
  },
}
</script>

<style lang="scss">
.usuarios {
  margin: 0px 15px;

  .btn-acoes {
    display: flex;
    align-items: center;

    .btn-acoes-itens {
      flex: 1;
    }
  }
}
</style>
